var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { Component, Watch } from 'vue-property-decorator';
import DeliverService from '@/api/DeliverService';
import PrintPreview from './component/PrintPreview.vue';
import GlobalVue from "@/globalVue";
import { UrlHelper } from "@/helper/UrlWrapper";
import { mapGetters } from "vuex";
import PrintConfig from '@/page/printconfig/List.vue';
import _ from 'lodash';
var PrintSort = (function (_super) {
    __extends(PrintSort, _super);
    function PrintSort() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.filter = {
            print_num: 1,
            dimension: 3,
            goods_name: '',
            shop_route: '',
            shop_name: '',
            depot_name: '',
        };
        _this.orderIds = '';
        _this.type = 1;
        _this.list = [];
        _this.loading = false;
        _this.isShowTip = true;
        _this.selected = [];
        _this.isEdit = false;
        _this.keyword = '';
        _this.goodsIndex = -1;
        _this.goodsOptions = [];
        _this.shopRouteOptions = [];
        _this.shopOptions = [];
        _this.depotOptions = [];
        return _this;
    }
    PrintSort.prototype.dimensionWatch = function (val) {
        localStorage.setItem('printSortDimension', String(val));
        this.filter.goods_name = '';
        this.filter.shop_route = '';
        this.filter.shop_name = '';
        this.filter.depot_name = '';
    };
    PrintSort.prototype.getSearchOptions = function () {
        var _this = this;
        this.goodsOptions = [{
                id: '',
                name: '全部货品',
            },];
        this.shopRouteOptions = [{
                id: '',
                name: '全部线路',
            }];
        this.shopOptions = [{
                id: '',
                name: '全部门店',
            },];
        this.depotOptions = [{
                id: '',
                name: '全部仓库',
            },];
        var hasEmptyRoute = false;
        this.list.forEach(function (item) {
            _this.initOptions(_this.goodsOptions, item.goods_name);
            _this.initOptions(_this.shopRouteOptions, item.shop_route);
            _this.initOptions(_this.shopOptions, item.shop_name);
            _this.initOptions(_this.depotOptions, item.depot_name);
            if (!item.shop_route || item.shop_route === '' || item.shop_route === null || item.shop_route === undefined) {
                hasEmptyRoute = true;
            }
        });
        if (hasEmptyRoute) {
            this.shopRouteOptions.splice(1, 0, {
                id: 'NO_ROUTE',
                name: '无线路'
            });
        }
        console.log(1111, this.shopRouteOptions);
    };
    PrintSort.prototype.initOptions = function (option, field) {
        var goods = {
            id: field,
            name: field,
        };
        var isExist = option.some(function (good) { return good.id === goods.id; });
        if (!isExist) {
            option.push(goods);
        }
    };
    PrintSort.prototype.changeGoods = function (val) {
        this.doChange();
    };
    PrintSort.prototype.changeShopRoute = function (val) {
        this.doChange();
    };
    PrintSort.prototype.changeShop = function (val) {
        this.doChange();
    };
    PrintSort.prototype.changeDepot = function (val) {
        this.doChange();
    };
    PrintSort.prototype.doChange = function () {
        var _this = this;
        this.list = this.list.map(function (item) {
            var routeMatch = false;
            if (_this.filter.shop_route === '') {
                routeMatch = true;
            }
            else if (_this.filter.shop_route === 'NO_ROUTE') {
                routeMatch = !item.shop_route || item.shop_route === '' || item.shop_route === null || item.shop_route === undefined;
            }
            else {
                routeMatch = item.shop_route === _this.filter.shop_route;
            }
            if ((item.goods_name === _this.filter.goods_name || _this.filter.goods_name == '') &&
                routeMatch &&
                (item.shop_name === _this.filter.shop_name || _this.filter.shop_name == '') &&
                (item.depot_name === _this.filter.depot_name || _this.filter.depot_name == '')) {
                item.is_show = true;
            }
            else {
                item.is_show = false;
            }
            return item;
        });
    };
    PrintSort.prototype.created = function () {
        this.service = DeliverService.getInstance();
        var isShowTip = localStorage.getItem('isShowPrintSortTip');
        if (isShowTip == 'false') {
            this.isShowTip = false;
        }
        var savedDimension = Number(localStorage.getItem('printSortDimension'));
        if ([1, 2, 3, 4].includes(savedDimension)) {
            this.filter.dimension = savedDimension;
        }
        var savedPrintNum = Number(localStorage.getItem('printSortPrintNum'));
        if ([-1, 0, 1, 2, 3].includes(savedPrintNum)) {
            this.filter.print_num = savedPrintNum;
        }
        console.log('isShowTip>>>', isShowTip);
        this.getList();
        this.debounceSearchGood = _.debounce(this.searchGoods, 200);
    };
    PrintSort.prototype.keywordChange = function (val) {
        this.debounceSearchGood(val);
    };
    PrintSort.prototype.goodsIndexChange = function (val) {
        if (this.goodsIndex > -1 && this.searchGoodsList.length) {
            this.scrollToGoods();
        }
    };
    PrintSort.prototype.getHighlightClasses = function (row) {
        var _a = this, activeGoods = _a.activeGoods, searchGoodsList = _a.searchGoodsList;
        var index = searchGoodsList.findIndex(function (good) { return good.unique_key === row.unique_key; });
        var classes = '';
        if (index > -1) {
            classes = 'highlight';
        }
        if (row.unique_key === activeGoods.unique_key) {
            classes += ' current';
        }
        return classes;
    };
    PrintSort.prototype.scrollToGoods = function () {
        var _a = this, goodsIndex = _a.goodsIndex, searchGoodsList = _a.searchGoodsList;
        var tableEl = this.$refs.table.$el;
        var targetRow = searchGoodsList[goodsIndex];
        if (tableEl && targetRow) {
            var targetTop = document.getElementById(targetRow.unique_key).getBoundingClientRect().top;
            var listTop = tableEl.querySelector('.el-table__body').getBoundingClientRect().top;
            this.$refs.table.$refs.bodyWrapper.scrollTop = targetTop - listTop;
        }
    };
    PrintSort.prototype.searchGoods = function (val) {
        var list = this.searchGoodsList || [];
        this.goodsIndex = list.length ? 0 : -1;
    };
    PrintSort.prototype.nextGoods = function () {
        var list = this.searchGoodsList || [];
        if (!list.length) {
            return;
        }
        if (this.goodsIndex < list.length - 1) {
            this.goodsIndex += 1;
        }
        else {
            this.goodsIndex = 0;
        }
    };
    PrintSort.prototype.handleSelectChange = function (rows) {
        this.selected = rows;
    };
    PrintSort.prototype.multipleDel = function () {
        var _this = this;
        if (!this.selected.length) {
            return;
        }
        var filter = function (item) {
            return !_this.selected.some(function (s) { return s.unique_key === item.unique_key; });
        };
        this.list = this.list.filter(filter);
    };
    PrintSort.prototype.hookParam = function (param) {
        if (param === void 0) { param = {}; }
        for (var key in this.filter) {
            var value = this.filter[key];
            param[key] = value;
        }
        return param;
    };
    PrintSort.prototype.getList = function () {
        var _this = this;
        var param = {
            type: this.type,
            order_ids: this.orderIds
        };
        this.hookParam(param);
        this.loading = true;
        this.service.getSortingLabelList(param).then(function (res) {
            _this.loading = false;
            if (res.data.success) {
                var list = res.data.data;
                _this.list = list.map(function (item) {
                    item.print_num = 1;
                    item.is_show = true;
                    return item;
                });
                _this.changePrintNum(_this.filter.print_num);
                _this.doChange();
                _this.getSearchOptions();
            }
            else {
                _this.message.error(res.data.msg);
            }
        }).catch(function (err) {
            _this.loading = false;
            _this.message.error(err);
        });
    };
    PrintSort.prototype.resetData = function () {
        this.filter.dimension = 1;
        this.filter.print_num = 1;
        this.filter.goods_name = '';
        this.filter.shop_route = '';
        this.filter.shop_name = '';
        this.filter.depot_name = '';
        localStorage.removeItem('printSortDimension');
        localStorage.removeItem('printSortPrintNum');
        this.changePrintNum(this.filter.print_num);
    };
    PrintSort.prototype.changePrintNum = function (value) {
        var printNum = this.filter.print_num;
        localStorage.setItem('printSortPrintNum', String(printNum));
        this.list.forEach(function (item) {
            if (printNum === -1) {
                item.print_num = item.order_detail_amount - 0;
            }
            else if (printNum === 0) {
                item.print_num = item.order_detail_total_oamount - 0;
            }
            else {
                item.print_num = printNum;
            }
        });
    };
    PrintSort.prototype.handleCloseTip = function () {
        this.isShowTip = false;
        localStorage.setItem('isShowPrintSortTip', false);
    };
    PrintSort.prototype.toPrint = function () {
        GlobalVue.$emit('addTab', {
            component: PrintConfig,
            name: 112,
            title: "打印设置",
            showExist: true,
            cprops: {
                template_type: 21
            }
        });
    };
    PrintSort.prototype.previewRow = function (row) {
        var _this = this;
        var params = {
            type: this.type,
            dimension: this.filter.dimension,
            order_detail_ids: row.order_detail_ids,
        };
        this.service.printSortingLabel(params).then(function (res) {
            var data = res.data.data || [];
            var mm2px = 3.78;
            var width = 160 * mm2px + 50;
            var height = 140 * mm2px + 100;
            var instance = _this.$dialog(PrintPreview, {
                data: {
                    printData: data[0]
                }
            }, {
                title: "分拣标签预览",
                width: width,
                height: height,
                zIndex: 1002,
            }).instance;
        }, function (err) {
            _this.$message.error(err.message || err.msg);
        });
    };
    PrintSort.prototype.deleteRow = function (index) {
        this.list.splice(index, 1);
    };
    PrintSort.prototype.getGoodsIndexMap = function (list) {
        var totalGood = 0;
        var goodIndex = 1;
        var goodsIndexMap = {};
        var totalGoodsMap = {};
        list.forEach(function (item, i) {
            var key = item.order_detail_ids + "_" + item.goods_id + "_" + item.supplier_goods_id;
            if (!goodsIndexMap[key]) {
                goodsIndexMap[key] = goodIndex;
                goodIndex += 1;
            }
            if (!totalGoodsMap[key]) {
                totalGoodsMap[key] = 1;
                totalGood += 1;
            }
        });
        for (var key in goodsIndexMap) {
            var value = goodsIndexMap[key];
            goodsIndexMap[key] = value + "/" + totalGood;
        }
        return {
            map: goodsIndexMap,
        };
    };
    PrintSort.prototype.groupByField = function (data, field) {
        var result = [];
        if (field === 'depot_id') {
            var list1 = data.filter(function (item) { return !item[field]; });
            var list2 = data.filter(function (item) { return !!item[field]; });
            result = Object.values(list1.reduce(function (result, item) {
                var value = item['shop_id'];
                if (!result[value]) {
                    result[value] = [];
                }
                result[value].push(item);
                return result;
            }, {}));
            return result.concat(Object.values(list2.reduce(function (result, item) {
                var value = item[field];
                if (!result[value]) {
                    result[value] = [];
                }
                result[value].push(item);
                return result;
            }, {})));
        }
        return Object.values(data.reduce(function (result, item) {
            var value = item[field];
            if (!result[value]) {
                result[value] = [];
            }
            result[value].push(item);
            return result;
        }, {}));
    };
    PrintSort.prototype.handleGoodsIndex = function (index) {
        var _this = this;
        var goodsIndexMap = {};
        var sortType = this.filter.dimension;
        var groupFieldMap = {
            1: 'business_id',
            2: 'shop_id',
            3: 'depot_id',
            4: 'order_id'
        };
        var groupField = groupFieldMap[sortType];
        var orderIdMap = [];
        var goodIndex = 1;
        var startIndex = 0;
        var totalGood = 0;
        var totalPage = 0;
        var totalGoodsMap = {};
        var groupsGoodsMap = {};
        var table = this.$refs.table;
        var list = table.store.states.data || [];
        var groupArr = this.groupByField(list, groupField);
        groupArr.forEach(function (group) {
            var map = _this.getGoodsIndexMap(group).map;
            Object.assign.apply(Object, [groupsGoodsMap].concat(map));
        });
        list.forEach(function (item, i) {
            var key = item.goods_id + "_" + item.supplier_goods_id;
            if (i >= index) {
                orderIdMap.push(item.order_detail_ids + "_" + item.print_num);
            }
            else {
                startIndex += item.print_num;
            }
            totalPage += item.print_num;
            if (!totalGoodsMap[key]) {
                totalGoodsMap[key] = 1;
                totalGood += 1;
            }
        });
        var result = {
            field: groupField,
            orderIds: orderIdMap,
            startIndex: startIndex,
            groupsGoodsMap: groupsGoodsMap,
            totalPage: totalPage
        };
        return result;
    };
    PrintSort.prototype.printStartAt = function (index) {
        this.toPrintPage(index);
    };
    PrintSort.prototype.toPrintPage = function (goodsIndex) {
        if (goodsIndex === void 0) { goodsIndex = 0; }
        var url = "./static/js/print/purOrderSortTagPrint.html";
        var table = this.$refs.table;
        var list = table.store.states.data || [];
        var _a = this.handleGoodsIndex(goodsIndex), groupsGoodsMap = _a.groupsGoodsMap, field = _a.field, orderIds = _a.orderIds, startIndex = _a.startIndex, totalPage = _a.totalPage;
        url = UrlHelper.addParam(url, 'type', "newPurSortingTag");
        url = UrlHelper.addParam(url, 'order_id', orderIds.join(","));
        url = UrlHelper.addParam(url, 'goods_id_index', JSON.stringify(groupsGoodsMap));
        url = UrlHelper.addParam(url, 'group_field', field);
        url = UrlHelper.addParam(url, 'start_page_index', startIndex);
        url = UrlHelper.addParam(url, 'total_page', totalPage);
        url = UrlHelper.addParam(url, 'token', this.user.token);
        url = UrlHelper.addParam(url, 'dimension', this.filter.dimension);
        url = UrlHelper.addParam(url, 'order_type', this.type);
        UrlHelper.windowOpenIntercept(url);
        window._czc.push(["_trackEvent", '分拣标签打印', '分拣标签打印']);
    };
    PrintSort.prototype.cancel = function () {
        GlobalVue.$emit('closeTab', this);
    };
    __decorate([
        Watch('filter.dimension')
    ], PrintSort.prototype, "dimensionWatch", null);
    __decorate([
        Watch('keyword')
    ], PrintSort.prototype, "keywordChange", null);
    __decorate([
        Watch('goodsIndex')
    ], PrintSort.prototype, "goodsIndexChange", null);
    PrintSort = __decorate([
        Component({
            computed: __assign({}, mapGetters({
                "user": "user",
            }), { searchGoodsList: function () {
                    var _a = this, keyword = _a.keyword, list = _a.list;
                    return /^\s*$/.test(keyword) ? [] : list.filter(function (item) { return item.goods_name.includes(keyword); });
                },
                activeGoods: function () {
                    var _a = this, goodsIndex = _a.goodsIndex, searchGoodsList = _a.searchGoodsList;
                    return goodsIndex > -1 ? searchGoodsList[goodsIndex] : {};
                },
                tableHeight: function () {
                    var bodyHeight = document.documentElement.clientHeight;
                    var diffHeight = 220 + (this.isShowTip ? 34 : 0);
                    return bodyHeight - diffHeight;
                },
                displayList: function () {
                    var list = this.list;
                    console.log('displayList>>>', list);
                    return list.filter(function (item) { return item.is_show; });
                } }),
        })
    ], PrintSort);
    return PrintSort;
}(Vue));
export default PrintSort;
